var SPINJS = window.SPINJS = window.SPINJS || {};
var level;

SPINJS.BigWin = function (panel) {
	this.meter = $.div('bigwin').apply('meter', { animate: true }).removeClass('meter').addClass('reset');
	
	this.meter.prependTo(panel);
	panel.registerCash(this.meter, true);
	
	var levels = {
		win_1: { name: 'win_1' },
		win_2: { name: 'win_2' },
		win_3: { name: 'win_3' },
		
		bigwin_1: {
			name: 'bigwin_1',
			duration: 5,
			celebration: 'confetti',
		},
		
		bigwin_2: {
			name: 'bigwin_2',
			duration: 5,
			celebration: 'coins',
		},
		
		bigwin_3: {
			name: 'bigwin_3',
			duration: 5,
			celebration: 'fireworks',
		},
	};
	
	this.breakpoints = [ 1, 2, 5, 10, 25 ];
	this.levels = [
		[ levels.win_1 ],
		[ levels.win_2 ],
		[ levels.win_3 ],
		[ levels.bigwin_1 ],
		[ levels.bigwin_1, levels.bigwin_2 ],
		[ levels.bigwin_1, levels.bigwin_2, levels.bigwin_3 ],
	];
	
	this.celebrations = {};
	
	if (panel.type === 'desktop') {
		this.celebrations.confetti = new SPINJS.BigWin.Celebration([
			{
				src: require('../images-desktop/celebrations/confetti.webm'),
				position: 'left',
				width: '24%',
			},
			{
				src: require('../images-desktop/celebrations/confetti.webm'),
				position: 'right',
				width: '24%',
			},
		], panel);
		
		this.celebrations.coins = new SPINJS.BigWin.Celebration([
			{
				src: require('../images-desktop/celebrations/coins.webm'),
				position: 'middle',
				width: '82%',
			},
		], panel);
		
		this.celebrations.fireworks = new SPINJS.BigWin.Celebration([
			{
				src: require('../images-desktop/celebrations/fireworks.webm'),
				position: 'middle',
				width: '95%',
			},
		], panel);
	}
};

SPINJS.BigWin.prototype.play = function (factor, index) {
	if (!index) {
		for (index = 0; index < this.breakpoints.length; index++) {
			if (factor < this.breakpoints[index]) {
				break;
			}
		}
	}
	
	level = this.levels[index];
	
	var start = game.sounds.context.currentTime;
	
	var total = level.reduce(function (total, level) {
		level.source = game.sounds.play([ 'win', level.name ], total);
		
		var duration = 2;
		
		if(level.duration || level.source) {
			duration = (level.duration || level.source.buffer.duration);
		}
		
		if (level.celebration) {
			level.timer = setTimeout(function () {
				if (this.celebrations[level.celebration]) {
					this.celebrations[level.celebration].play();
				}
				
				this.meter.attr('class', level.name);
			}.bind(this), total * 1000);
		}
		
		return total + duration;
	}.bind(this), 0);
	
	level.timer = setTimeout(function () {
		this.stop(true);
	}.bind(this), total * 1000 + 5000);
	
	this.playing = true;
	
	return {
		get progress() {
			return (game.sounds.context.currentTime - start) / total;
		},
	};
};

SPINJS.BigWin.prototype.stop = function (immediate) {
	this.playing = false;
	
	if(immediate){
		game.sounds.stop('win');
	}
	
	else {
		if(level){
			game.sounds.fade(['win', level[0].name], 1, 0, 0.5);
			setTimeout(function() {
				game.sounds.stop('win');
			}, 500);
		}
	}
	
	for (var i in this.levels) {
		if (this.levels[i].timer) {
			clearTimeout(this.levels[i].timer);
			
			if (!immediate) {
				this.levels[i].timer = setTimeout(function () {
					this.stop(true);
				}.bind(this), 5000);
			}
		}
		
		for (var j in this.levels[i]) {
			if (j === 'timer') {
				continue;
			}
			
			if (this.levels[i][j].timer) {
				clearTimeout(this.levels[i][j].timer);
				delete this.levels[i][j].timer;
				
				this.meter.attr('class', this.levels[i][j].name);
			}
		}
	}
	
	for (var key in this.celebrations) {
		this.celebrations[key].stop();
	}
	
	this.meter.update(true);
	
	if (immediate) {
		this.meter.addClass('reset');
	}
};

SPINJS.BigWin.Celebration = function (items, panel) {
	if (!/Chrome/.test(navigator.userAgent)) {
		return;
	}
	
	this.videos = items.map(function (item) {
		var video = $.element('video').attr('poster', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=');
		var source = $.element('source').attr('type', 'video/webm');
		
		video.on('ended', function () {
			this.css('display', 'none');
		});
		
		var style = {
			display: 'none',
			position: 'absolute',
			bottom: '100%',
			width: item.width,
		};
		
		switch (item.position) {
			case 'left':
				style.left = '0%';
			break;
			
			case 'right':
				style.right = '0%';
			break;
			
			case 'middle':
				style.left = '50%';
				style.transform = 'translateX(-50%)';
			break;
		}
		
		video.css(style);
		source.appendTo(video);
		video.prependTo(panel);
		
		setTimeout(function () {
			var url = /((?:ht|f)tps?):\/\/([A-Za-z0-9-_\.]+)(?::([0-9]+))?(\/(?:[A-Za-z0-9-_\/\.]*))*/;
			var path = panel.css('background-image').match(url)[0];
			path = path.slice(0, path.lastIndexOf('/') + 1);
			
			source.attr('src', base + item.src);
		}.bind(this), 100);
		
		return video;
	});
};

SPINJS.BigWin.Celebration.prototype.play = function () {
	if (!this.videos) {
		return;
	}
	
	this.videos.map(function (video) {
		video.css('display', 'block');
		video.el.load();
		video.el.play();
	});
};

SPINJS.BigWin.Celebration.prototype.stop = function () {
	if (!this.videos) {
		return;
	}
	
	this.videos.map(function (video) {
		video.el.pause();
		video.css('display', 'none');
	});
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/bigwin.js
 **/